import BaseApi from '@/core/HttpResources/BaseApi';
import UsuarioRole from '@/models/usuarios/usuarioRole.model';
import Role from '@/models/usuarios/role.model';
import Usuario from '@/models/usuarios/usuario.model';

export default class UsuarioService {
    
    async getUserRoles(userId: number): Promise<Array<Role>> {
        var baseApi = new BaseApi("usuario/" + userId +"/roles");
        return new Promise<Array<Role>>((resolve, reject) => baseApi.request('GET', String(), null, {}, (response) => resolve(response.data), reject, () => { }))
    }
    async getUserPermissionsGroupedByCategory(userId: number): Promise<Array<any>> {
        var baseApi = new BaseApi("usuario/" + userId +"/permissions/group/category");
        return new Promise<Array<any>>((resolve, reject) => baseApi.request('GET', String(), null, {}, (response) => resolve(response.data), reject, () => { }))
    }

    async attachRolToUser(usuarioRole:  UsuarioRole): Promise<Array<any>> {
        var baseApi = new BaseApi("usuario/attach/role");
        return new Promise<Array<any>>((resolve, reject) => baseApi.request('POST', String(), usuarioRole, {}, (response) => resolve(response.data), reject, () => { }))
    }
    async quitRolToUser(rolId:  number): Promise<Array<any>> {
        var baseApi = new BaseApi("usuario/quit/role/" + rolId);
        return new Promise<Array<any>>((resolve, reject) => baseApi.request('DELETE', String(), null, {}, (response) => resolve(response.data), reject, () => { }))
    }

    async getUserById(userId: number){
        var baseApi = new BaseApi("usuario/" + userId);
        return new Promise<Usuario>((resolve, reject) => baseApi.request('GET', String(), null, {}, (response) => resolve(response.data), reject, () => { }))
    }
    async updateUser(usuario: Usuario){
        var baseApi = new BaseApi("usuario/" + usuario.id);
        return new Promise<Usuario>((resolve, reject) => baseApi.request('PUT', String(), usuario, {}, (response) => resolve(response.data), reject, () => { }))
    }
    async updateUserPassword(changePassword: any){
        var baseApi = new BaseApi("usuario/changePassword");
        return new Promise<Usuario>((resolve, reject) => baseApi.request('PUT', String(), changePassword, {}, (response) => resolve(response.data), reject, () => { }))
    }
}